import { render, staticRenderFns } from "./OrganizationPlanAlert.vue?vue&type=template&id=010f35f4"
import script from "./OrganizationPlanAlert.vue?vue&type=script&lang=ts"
export * from "./OrganizationPlanAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports